import type { ReactNode } from 'react';
import React, { Component } from 'react';

// Components
import AkTooltip from '@atlaskit/tooltip/Tooltip';
import type { PositionType } from '@atlaskit/tooltip/types';

import type { ShortcutListenerProps } from '@confluence/shortcuts';
import { ShortcutListener, getShortcutString } from '@confluence/shortcuts';

interface Props {
	children: ReactNode;
	description?: string;
	shortcutAccelerator: string;
	shortcutAllowInDialog?: boolean;
	shortcutListener: ShortcutListenerProps['listener'] | null;
	isDisabled?: boolean;
	position: PositionType;
}

export class TooltipWithShortcut extends Component<Props> {
	static defaultProps = {
		isDisabled: false,
		description: '',
	};

	render() {
		const {
			children,
			description,
			shortcutAccelerator,
			shortcutAllowInDialog,
			shortcutListener,
			isDisabled,
			...otherTooltipProps
		} = this.props;

		const shortcutString = shortcutAccelerator
			? ` (${getShortcutString(shortcutAccelerator)})`
			: '';

		return isDisabled ? (
			children
		) : (
			<AkTooltip content={`${description}${shortcutString}`} {...otherTooltipProps}>
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */}
				<span style={{ display: 'inline-block' }}>
					{children}
					{!shortcutListener ? null : (
						<ShortcutListener
							accelerator={shortcutAccelerator}
							allowInDialog={shortcutAllowInDialog}
							listener={shortcutListener}
						/>
					)}
				</span>
			</AkTooltip>
		);
	}
}
